export default function Hero() {
  return (
    <section className="pt-32 pb-20 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          <div>
            <h1 className="text-5xl lg:text-6xl font-bold text-gray-900 mb-6 leading-tight">
              Video Production for Long Island Businesses
            </h1>
            <p className="text-lg text-gray-600 mb-8 leading-relaxed">
              Professional video production services that capture your brand's story and engage your audience. From corporate videos to social media content, we bring your vision to life with cinematic quality.
            </p>
            
            <div className="flex items-center gap-4 mb-8">
              <a 
                href="tel:6315675656"
                className="text-2xl font-bold text-[#1E3A8A] hover:text-[#1E3A8A]/80 transition-colors cursor-pointer"
              >
                (631) 567-5656
              </a>
            </div>

            <div className="flex flex-wrap gap-4">
              <a 
                href="#contact"
                className="px-8 py-3.5 bg-[#1E3A8A] text-white font-medium rounded-full hover:bg-[#1E3A8A]/90 transition-colors whitespace-nowrap cursor-pointer"
              >
                Get a Free Quote
              </a>
              <a 
                href="#services"
                className="px-8 py-3.5 border-2 border-[#1E3A8A] text-[#1E3A8A] font-medium rounded-full hover:bg-[#1E3A8A] hover:text-white transition-colors whitespace-nowrap cursor-pointer"
              >
                View Services
              </a>
            </div>
          </div>

          <div className="relative">
            <div className="w-full h-[500px] rounded-2xl overflow-hidden shadow-2xl">
              <img 
                src="https://public.readdy.ai/ai/img_res/d2b1d2c646821a98bbaecf435a76bcd0.jpg"
                alt="Professional Video Production"
                className="w-full h-full object-cover object-top"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}